import React from 'react';
import ReactModal from 'react-modal';

import ProlongModalLayout from './ProlongModalLayout';

const ProlongModal = ({
  isOpen,
  paramReq,
  handleCloseModal,
  paramReqList,
  clientId,
  cashBoxId,
  page,
  status
}) => {
  return (
    <ReactModal
      isOpen={isOpen}
      contentLabel="Modal"
      className="modal-container clientContract-modal-container"
      overlayClassName="modal-overlay">
      <ProlongModalLayout
        paramReq={paramReq}
        handleCloseModal={handleCloseModal}
        paramReqList={paramReqList}
        clientId={clientId}
        cashBoxId={cashBoxId}
        page={page}
        status={status}
      />
    </ReactModal>
  );
};

export default ProlongModal;
